import React from "react";
import { Link } from "react-router-dom";
import Home from "./home";

export default function MasterCARD() {
  return (
    <div className="PageContent">
      <Home />
      <div className="tableDiv table-responsive content_centered colored_background push_downwards">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">CARD TYPE</th>
              <th scope="col">CARD BIN</th>
              <th scope="col"> INCLUDES</th>
              <th scope="col"> COUNTRY</th>
              <th scope="col">price</th>
              <th scope="col">status</th>
              <th scope="col">Buy now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Master Card</th>
              <td>552393*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td>521012*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td>525890*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td>524715*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td>518116*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td>516075*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td>552321*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td>544634*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td> 546638*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td>546783*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td> 519959*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td> 546633*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td> 4037840*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Master Card</th>
              <td> 544614*******</td>
              <td>
                {" "}
                First and last name, Bill Address,Zip Code Email, Phone Number,
                Csv,VBV Pass, CVV Pass,SSN
              </td>
              <td>USA</td>
              <td>$50</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer className="footer">
        <p> &copy;2023 Darknetlogs Logs Shop</p>
      </footer>
    </div>
  );
}
